const state = {
    accommodation: null,
};

export default state;